import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { inject, observer } from 'mobx-react';
import { fetch } from '../../utils/api-wrapper';
import AuthUtils from '../../utils/auth-utils';
import logo from './../../assets/img/logo-xpens-cropped.svg';
import Translator from '../../locales/translator';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PwaInstallButton from '../../components/PwaInstallButton';

const oidcConfig = {
  authority: process.env.REACT_APP_OIDC_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: window.location.origin + '/signin',
  response_type: 'code',
  scope: process.env.REACT_APP_OIDC_SCOPES || 'openid profile email',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

const userManager = new UserManager(oidcConfig);

const OidcLogin = inject("data")(observer(({ data }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(window.location.search.includes('code='));
  const navigate = useNavigate();
  const updateLang = () => {
    data.t.switchLang();
    data.t = new Translator();
  };
  const getInternalToken = (user) => {
    setLoading(true);
    fetch("/oidc/auth", "POST", {id_token: user.id_token}, (response) => {
      AuthUtils.handleAuthSuccess(response, data, navigate, setError);
    }, (error) => {
      setLoading(false);
      // XPEN-3626: single sign-on switched off for the firm or for this person.
      const body = error?.response?.data;
      if (body?.error === 'sso_disabled') {
        setError(data.t.read(body.scope === 'user' ? 'errors.sso_disabled_user' : 'errors.sso_disabled'));
      } else {
        setError(error);
      }
    })
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    userManager.signinRedirect();
  }

  useEffect(() => {
    if (window.location.search.includes('code=')) {
      userManager.signinRedirectCallback()
        .then(user => {
          getInternalToken(user);
        })
        .catch(e => {
          setLoading(false);
          setError('OIDC authentication error');
        });
    }
    // eslint-disable-next-line
  }, []);

  return <div>
            <div
                className="pointer position-absolute"
                style={{ right: 20, top: 20, display: 'flex', alignItems: 'center', gap: 16 }}
            >
                <PwaInstallButton data={data} title={data.t.read('download_app')} />
                <button
                    onClick={() => navigate('/login')}
                    className="btn btn-outline-secondary btn-sm"
                    style={{ whiteSpace: 'nowrap' }}
                    data-testid="backdoor-login-button"
                >
                    {data.t.read("signin_with_password")}
                </button>
                <span onClick={updateLang} style={{ cursor: 'pointer' }}>
                {
                    data.t.lang === "fr" ?
                        <span><strong>Français</strong> / English</span> :
                        <span>Français / <strong>English</strong></span>
                }
                </span>
            </div>
            <div className="page-centered">
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className={`text-center ${data.isMobile ? 'mb-6' : 'mb-5'}`}>
                        <img src={logo} alt="Head Logo" />
                    </div>
                    <div className={`alert-section ${data.isMobile ? 'mb-4' : ''}`}>
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {typeof error === 'string' ? error : error.message}
                            </div>
                        )}
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <button
                                disabled={loading}
                                className={`btn btn-block btn-primary btn-lg ${data.isMobile ? 'py-2' : ''}`}
                                data-testid="signin-button"
                            >
                                {data.t.read("signin.signin")}
                                {loading && <FontAwesomeIcon icon={faSync} className="ml-2 infinite-rotate" />}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
}));

export default OidcLogin; 